var map = {
	"./decidim/avatar-multiuser.png": 4982,
	"./decidim/brands/google.svg": 13913,
	"./decidim/cc-badge.png": 18952,
	"./decidim/decidim-logo.svg": 10036,
	"./decidim/default-avatar.svg": 96140,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 35768,
	"./decidim/icons.svg": 27271,
	"./decidim/pattern.png": 12904,
	"./decidim/placeholder-card-g.svg": 75981,
	"./decidim/placeholder-card-l.svg": 48934,
	"./decidim/placeholder.jpg": 14853,
	"./decidim/remixicon.symbol.svg": 4233,
	"./decidim/vendor/leaflet/layers-2x.png": 83144,
	"./decidim/vendor/leaflet/layers.png": 98199,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 27778,
	"./decidim/vendor/leaflet/marker-icon.png": 57769,
	"./decidim/vendor/leaflet/marker-shadow.png": 10342,
	"./decidim/vendor/social-share-button/douban.svg": 37928,
	"./decidim/vendor/social-share-button/email.svg": 1797,
	"./decidim/vendor/social-share-button/facebook.svg": 29947,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 75477,
	"./decidim/vendor/social-share-button/hacker_news.svg": 93077,
	"./decidim/vendor/social-share-button/linkedin.svg": 51293,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 66734,
	"./decidim/vendor/social-share-button/pinterest.svg": 23195,
	"./decidim/vendor/social-share-button/reddit.svg": 16879,
	"./decidim/vendor/social-share-button/telegram.svg": 21922,
	"./decidim/vendor/social-share-button/tumblr.svg": 3425,
	"./decidim/vendor/social-share-button/twitter.svg": 9524,
	"./decidim/vendor/social-share-button/vkontakte.svg": 1578,
	"./decidim/vendor/social-share-button/wechat.svg": 54613,
	"./decidim/vendor/social-share-button/whatsapp.svg": 77893,
	"./decidim/vendor/social-share-button/x.svg": 20165,
	"./decidim/vendor/social-share-button/xing.svg": 70203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73739;